import * as tslib_1 from "tslib";
import { AfterViewInit, ChangeDetectorRef, EventEmitter, ViewContainerRef } from '@angular/core';
import * as parseDMS from 'parse-dms';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { SearchApi } from '../../../api/search-api';
import { environment } from '../../../environment';
import { ESRI } from '../../../esri-loader-util';
import { BooleanConverter, InputConverter, JSONConverter } from '../../../inputConverter';
import { GeocodeService } from '../../../services/geocode.service';
import { LayerService } from '../../../services/layer.service';
import { MapService } from '../../../services/map.service';
import { BaseComponent } from '../../base.component';
var SearchComponent = /** @class */ (function (_super) {
    tslib_1.__extends(SearchComponent, _super);
    function SearchComponent(_vcr, authService, geocodeService, layerService, mapService, searchApi, cdr) {
        var _this = _super.call(this, _vcr, true) || this;
        _this.authService = authService;
        _this.geocodeService = geocodeService;
        _this.layerService = layerService;
        _this.mapService = mapService;
        _this.searchApi = searchApi;
        _this.cdr = cdr;
        _this.addressSymbolDefinition = {
            type: 'simple-marker',
            style: 'circle',
            color: 'yellow',
            size: '16px'
        };
        _this.addSelectionToMap = false;
        _this.maxResults = 100;
        _this.debounceTimer = 1000;
        _this.filterLayersBeforeAdd = false;
        _this.placeHolder = 'Enter search here...';
        _this.text = '';
        _this.selectedTypeName = 'feature';
        _this.results = {};
        _this.user = null;
        _this.excludeTypes = [];
        _this.enableNotificationSearch = false;
        _this.loading = false;
        _this.error = false;
        _this.point = null;
        _this.searchUpdated = new Subject();
        _this.typeResults = [];
        _this.onresultselected = new EventEmitter();
        _this.dontClear = false;
        _this.registerEvent('onresultselected', _this.onresultselected);
        _this.searchUpdated
            .pipe(debounceTime(_this.debounceTimer))
            .subscribe(function () {
            _this.search();
        });
        return _this;
    }
    SearchComponent.prototype.ngAfterViewInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b;
            var _this = this;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this;
                        if (!this.mapViewRef) return [3 /*break*/, 1];
                        _b = this.mapViewRef;
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.setupMapViewRef(this.mapViewRef)];
                    case 2:
                        _b = _c.sent();
                        _c.label = 3;
                    case 3:
                        _a.mapViewRef = _b;
                        this.mapService.mcMapView = this.mapViewRef;
                        this.authService.user.subscribe(function (user) {
                            _this.user = user;
                        });
                        return [4 /*yield*/, this.loadCoordinateFormatter()];
                    case 4:
                        _c.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SearchComponent.prototype.loadCoordinateFormatter = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!this.coordinateFormatter) return [3 /*break*/, 3];
                        _a = this;
                        return [4 /*yield*/, ESRI.CoordinateFormatter];
                    case 1:
                        _a.coordinateFormatter = _b.sent();
                        if (!!this.coordinateFormatter.isLoaded()) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.coordinateFormatter.load()];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    SearchComponent.prototype.documentClick = function (event) {
        if (!event.target || event.target.tagName !== 'MC-SEARCH') {
            this.hasFocus = false;
        }
    };
    SearchComponent.prototype.getTypeCount = function (type) {
        return this.results[type].length;
    };
    SearchComponent.prototype.textboxClick = function () {
        if (!this.hasFocus) {
            this.hasFocus = true;
            this.search();
        }
    };
    SearchComponent.prototype.selectType = function (typeName) {
        this.selectedTypeName = typeName;
    };
    SearchComponent.prototype.getPluralType = function (type) {
        var firstLetter = type.substring(0, 1).toUpperCase();
        var rest = type.substring(1);
        return "" + firstLetter + rest + "s";
    };
    SearchComponent.prototype.onTextboxChange = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.searchUpdated.next(this.text);
                return [2 /*return*/];
            });
        });
    };
    SearchComponent.prototype.search = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var latLong, tempTypeResults, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.loading = false;
                        this.error = false;
                        this.hasFocus = true;
                        this.dontClear = false;
                        this.point = null;
                        if (!(this.text.length && !this.text.includes('|') && !this.text.includes('/'))) return [3 /*break*/, 5];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 4, , 5]);
                        latLong = parseDMS(this.text);
                        if (!(latLong && latLong.lat && latLong.lon)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.loadCoordinateFormatter()];
                    case 2:
                        _b.sent();
                        this.point = this.coordinateFormatter.fromLatitudeLongitude(latLong.lat + " " + latLong.lon);
                        if (this.point) {
                            this.dontClear = true;
                            this.typeResults = [];
                            this.results = {};
                            tempTypeResults = {
                                name: 'feature',
                                pluralDisplayName: 'Features',
                                count: 1
                            };
                            this.typeResults.push(tempTypeResults);
                            this.cdr.detectChanges();
                        }
                        _b.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        _a = _b.sent();
                        return [3 /*break*/, 5];
                    case 5:
                        this.normalTextSearch();
                        return [2 /*return*/];
                }
            });
        });
    };
    SearchComponent.prototype.showLatLongOnMap = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var Graphic, pointGraphic, pointName;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ESRI.Graphic];
                    case 1:
                        Graphic = _a.sent();
                        pointGraphic = new Graphic({
                            geometry: this.point,
                            symbol: {
                                type: 'simple-marker',
                                style: 'circle',
                                color: 'yellow',
                                size: '16px'
                            }
                        });
                        pointName = "Point:   " + this.point.latitude + "  ,  " + this.point.longitude;
                        return [4 /*yield*/, this.addGraphicAndZoomToIt(pointGraphic, pointName)];
                    case 2:
                        _a.sent();
                        this.text = '';
                        this.typeResults = [];
                        this.point = null;
                        return [2 /*return*/];
                }
            });
        });
    };
    SearchComponent.prototype.cancelPointOnMap = function () {
        this.typeResults = [];
        this.text = '';
        this.point = null;
    };
    SearchComponent.prototype.addGraphicAndZoomToIt = function (pointGraphic, title) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(!this.graphicsLayer || !this.graphicsLayer.parent)) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.layerService.addGraphicsLayer({ title: title })];
                    case 1:
                        _a.graphicsLayer = _b.sent();
                        _b.label = 2;
                    case 2:
                        this.graphicsLayer.add(pointGraphic);
                        this.layerService.zoomToGraphic(pointGraphic);
                        return [2 /*return*/];
                }
            });
        });
    };
    SearchComponent.prototype.normalTextSearch = function () {
        var validSearch = true;
        if (this.text.length > 0) {
            var endChar = this.text.substr(-1);
            if (endChar === ' ' || endChar === ',') {
                validSearch = false;
            }
            if (validSearch) {
                this.retrieveResults();
            }
        }
        else {
            this.clearResults();
        }
    };
    SearchComponent.prototype.retrieveResults = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1, _a, e_2, _b, textForThisSearch, userId, newResults, featuresByGroup, _c, _d, result, _e, _f, groupFeatures, er_1;
            return tslib_1.__generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        this.loading = true;
                        if (!this.dontClear) {
                            this.typeResults = [];
                        }
                        this.cdr.detectChanges();
                        _g.label = 1;
                    case 1:
                        _g.trys.push([1, 3, , 4]);
                        textForThisSearch = this.text;
                        userId = null;
                        if (this.user) {
                            userId = this.user.id;
                        }
                        if (typeof this.maxResults !== 'number') {
                            this.maxResults = parseInt(this.maxResults, 10);
                        }
                        return [4 /*yield*/, this.searchApi.getResults(textForThisSearch, userId, '', this.maxResults, this.excludeTypes, environment.appId)];
                    case 2:
                        newResults = _g.sent();
                        if (textForThisSearch === this.text) {
                            this.results = this.filterResults(newResults);
                            if (this.results && this.results.feature && this.results.feature.length && this.results.feature.length > 0) {
                                featuresByGroup = new Map();
                                try {
                                    for (_c = tslib_1.__values(this.results.feature), _d = _c.next(); !_d.done; _d = _c.next()) {
                                        result = _d.value;
                                        if (!featuresByGroup.has(result.layerTitle)) {
                                            featuresByGroup.set(result.layerTitle, []);
                                        }
                                        featuresByGroup.get(result.layerTitle).push(result);
                                    }
                                }
                                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                                finally {
                                    try {
                                        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                                    }
                                    finally { if (e_1) throw e_1.error; }
                                }
                                // Sort each group alphabetically.
                                this.results.feature = [];
                                try {
                                    for (_e = tslib_1.__values(featuresByGroup.values()), _f = _e.next(); !_f.done; _f = _e.next()) {
                                        groupFeatures = _f.value;
                                        groupFeatures.sort(function (a, b) { return a.primaryText.localeCompare(b.primaryText); });
                                        this.results.feature = this.results.feature.concat(groupFeatures);
                                    }
                                }
                                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                                finally {
                                    try {
                                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                                    }
                                    finally { if (e_2) throw e_2.error; }
                                }
                            }
                            this.loading = false;
                            this.setTypeResults();
                            this.addWholeRouteResult();
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        er_1 = _g.sent();
                        console.error(er_1);
                        this.loading = false;
                        this.error = true;
                        return [3 /*break*/, 4];
                    case 4:
                        this.cdr.detectChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    SearchComponent.prototype.filterResults = function (results) {
        var e_3, _a, e_4, _b;
        try {
            for (var _c = tslib_1.__values(this.searchApi.getSearchResultTypes(this.excludeTypes)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var type = _d.value;
                var newList = [];
                var uninqueKeys = [];
                try {
                    for (var _e = tslib_1.__values(results[type.name]), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var result = _f.value;
                        if (result.tertiaryText) {
                            if (result.tertiaryText.toUpperCase().indexOf('NOCO') > -1) {
                                result.layerTitle += ' - NOCO';
                            }
                            else if (result.tertiaryText.toUpperCase().indexOf('PAYROLL') > -1) {
                                result.layerTitle += ' - Payroll';
                            }
                        }
                        var uninqueKey = result.layerTitle + "_" + result.primaryText + "_" + result.layerId;
                        if (uninqueKeys.indexOf(uninqueKey) < 0) {
                            uninqueKeys.push(uninqueKey);
                            newList.push(result);
                        }
                        var idx = uninqueKeys.indexOf(uninqueKey);
                        if (idx > -1) {
                            if (!newList[idx].objectIds) {
                                newList[idx].objectIds = [];
                            }
                            newList[idx].objectIds.push(result.objectId);
                        }
                    }
                }
                catch (e_4_1) { e_4 = { error: e_4_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_4) throw e_4.error; }
                }
                results[type.name] = newList;
                if (results[type.name].length > this.maxResults) {
                    results[type.name].length = this.maxResults;
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return results;
    };
    SearchComponent.prototype.setTypeResults = function () {
        var e_5, _a;
        if (!this.dontClear) {
            this.typeResults = [];
        }
        var _loop_1 = function (type) {
            var typeWithCount = this_1.typeResults.find(function (x) { return x.name === type.name; });
            if (typeWithCount) {
                typeWithCount.count += this_1.results[type.name].length;
            }
            else {
                typeWithCount = tslib_1.__assign({}, type, {});
                typeWithCount.count = this_1.results[type.name].length;
                this_1.typeResults.push(typeWithCount);
            }
        };
        var this_1 = this;
        try {
            for (var _b = tslib_1.__values(this.searchApi.getSearchResultTypes(this.excludeTypes)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var type = _c.value;
                _loop_1(type);
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_5) throw e_5.error; }
        }
        this.selectedTypeName = this.typeResults.find(function (results) { return !!results.count; }) ? this.typeResults.find(function (results) { return !!results.count; }).name : '';
    };
    SearchComponent.prototype.addWholeRouteResult = function () {
        if (this.typeResults && this.typeResults.some(function (tr) { return tr.name === 'feature' && tr.count > 0; })) {
            var featureResults = this.results.feature;
            var rmsLayers_1 = environment.searchReplacement.find(function (sr) { return sr.replacementFormat.toLowerCase().startsWith('rms'); });
            if (rmsLayers_1) {
                var firstResultIndex = featureResults.findIndex(function (r) { return rmsLayers_1.layerIds.includes(r.layerId); });
                if (firstResultIndex >= 0) {
                    var firstResult = featureResults[firstResultIndex];
                    var crsParts = firstResult.primaryText.split('|');
                    featureResults.splice(firstResultIndex, 0, {
                        layerId: firstResult.layerId,
                        layerTitle: firstResult.layerTitle,
                        type: firstResult.type,
                        primaryText: crsParts.filter(function (_x, i, a) { return i < a.length - 1; }).join('|'),
                        secondaryText: firstResult.secondaryText,
                        tertiaryText: "SR " + crsParts[1]
                    });
                }
            }
        }
    };
    SearchComponent.prototype.addResultToMap = function (result) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var res;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.selectedItem = result;
                        this.hasFocus = false;
                        if (!this.addSelectionToMap) return [3 /*break*/, 2];
                        this.onTextboxChange();
                        this.clearResults();
                        return [4 /*yield*/, this.addResultToMapBasedOnType(result)];
                    case 1:
                        res = _a.sent();
                        if (!res) {
                            res = result;
                        }
                        this.onresultselected.emit({ type: result.type, result: res });
                        this.text = '';
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /* tslint:disable:cyclomatic-complexity */
    SearchComponent.prototype.addResultToMapBasedOnType = function (result) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var name, sapNotif, notifNumber, nocoPayroll, data_1, _a, maps, map, layerSettings, query, parts_1, searchKeys, searchKey, searchKeys, values, searchKey, i, subquery, featureLayerSettings;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        name = result.primaryText;
                        sapNotif = result.primaryText;
                        notifNumber = null;
                        if (this.enableNotificationSearch && environment.searchReplacement.filter(function (x) { return x.layerIds.includes(result.layerId); })[0]) {
                            notifNumber = result.primaryText.match(/\d+/);
                            if (notifNumber) {
                                sapNotif = result.primaryText.substring(notifNumber.index);
                            }
                        }
                        nocoPayroll = '';
                        if (result.tertiaryText) {
                            if (result.tertiaryText.toUpperCase().indexOf('NOCO') > -1) {
                                nocoPayroll = ' NOCO';
                            }
                            else if (result.tertiaryText.toUpperCase().indexOf('PAYROLL') > -1) {
                                nocoPayroll = ' Payroll';
                            }
                        }
                        if (result.layerTitle) {
                            data_1 = environment.searchReplacement.filter(function (x) { return x.layerIds.includes(result.layerId); });
                            if (this.enableNotificationSearch && data_1 && data_1.length && environment.sapLayerIds.some(function (item) { return data_1[0].layerIds.includes(item); })) {
                                name = data_1[0].replacementFormat.replace('{sapNotif}', 'Notification ' + sapNotif).replace('{sapStatus}', data_1[0].sapStatus ? data_1[0].sapStatus : '').replace('{nocoPayroll}', nocoPayroll ? ('by' + nocoPayroll) : '');
                            }
                            else if (data_1 && data_1.length && data_1[0].replacementFormat.includes('{primaryText}')) {
                                name = data_1[0].replacementFormat.replace('{primaryText}', result.primaryText);
                            }
                            else {
                                name = result.layerTitle;
                            }
                        }
                        _a = result.type;
                        switch (_a) {
                            case 'address': return [3 /*break*/, 1];
                            case 'map': return [3 /*break*/, 3];
                            case 'layer': return [3 /*break*/, 6];
                            case 'feature': return [3 /*break*/, 10];
                        }
                        return [3 /*break*/, 12];
                    case 1: return [4 /*yield*/, this.addGraphicForAddressResult(result)];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 13];
                    case 3: return [4 /*yield*/, this.mapService.getMaps([result.id])];
                    case 4:
                        maps = _b.sent();
                        map = maps[0];
                        return [4 /*yield*/, this.mapService.openMap(map)];
                    case 5:
                        _b.sent();
                        return [2 /*return*/, map];
                    case 6:
                        layerSettings = { id: result.id, name: name, zoomToLayer: true };
                        if (!this.filterLayersBeforeAdd) return [3 /*break*/, 7];
                        window.dispatchEvent(new CustomEvent('addingMapcoreLayersToMap', { detail: [layerSettings], composed: true }));
                        return [3 /*break*/, 9];
                    case 7: return [4 /*yield*/, this.layerService.addMapcoreLayersToMap([layerSettings])];
                    case 8: return [2 /*return*/, _b.sent()];
                    case 9: return [3 /*break*/, 13];
                    case 10:
                        query = void 0;
                        if (result.objectIds && result.objectIds.length > 1) {
                            query = { field: 'objectid', operator: 'IN', value: result.objectIds.toString() };
                        }
                        else if (result.objectId) {
                            query = { field: 'objectid', operator: '=', value: result.objectId.toString() };
                        }
                        if (result.primaryText.indexOf(': ') > 0) {
                            parts_1 = result.primaryText.split(': ');
                            searchKeys = environment.featureSearchKeys.filter(function (x) { return parts_1[0] === x.prefix; });
                            if (searchKeys.length > 0 && parts_1.length > 1) {
                                searchKey = searchKeys[0];
                                query.field = searchKey.column;
                                query.value = parts_1[1].trim();
                            }
                        }
                        else if (result.primaryText.indexOf('|') > 0) {
                            searchKeys = environment.featureSearchKeys.filter(function (x) { return x.pipes; });
                            if (searchKeys.length > 0) {
                                values = result.primaryText.split('|');
                                query = { operator: 'AND', subqueries: [] };
                                searchKey = searchKeys[0];
                                for (i = 0; i < searchKey.columns.length; i++) {
                                    if (values[i]) {
                                        subquery = { field: searchKey.columns[i], operator: '=', value: values[i] };
                                        query.subqueries.push(subquery);
                                    }
                                }
                            }
                        }
                        featureLayerSettings = { id: result.layerId, name: name, query: query, zoomToLayer: true, identifyEnabled: true };
                        return [4 /*yield*/, this.layerService.addMapcoreLayersToMap([featureLayerSettings])];
                    case 11: return [2 /*return*/, _b.sent()];
                    case 12: return [3 /*break*/, 13];
                    case 13: return [2 /*return*/];
                }
            });
        });
    };
    SearchComponent.prototype.addGraphicForAddressResult = function (result) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var findResult, Graphic, candidate, point, pointGraphic, graphicsLayer;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.geocodeService.find(result.name, result.magicKey).toPromise()];
                    case 1:
                        findResult = _a.sent();
                        if (!(findResult.candidates.length > 0)) return [3 /*break*/, 5];
                        return [4 /*yield*/, ESRI.Graphic];
                    case 2:
                        Graphic = _a.sent();
                        candidate = findResult.candidates[0];
                        point = {
                            type: 'point',
                            x: candidate.location.x,
                            y: candidate.location.y,
                            spatialReference: findResult.spatialReference
                        };
                        pointGraphic = new Graphic({
                            geometry: point,
                            symbol: this.addressSymbolDefinition
                        });
                        return [4 /*yield*/, this.layerService.addGraphicsLayer({ title: candidate.address }, { identifyEnabled: true })];
                    case 3:
                        graphicsLayer = _a.sent();
                        graphicsLayer.add(pointGraphic);
                        return [4 /*yield*/, this.layerService.zoomToGraphic(pointGraphic)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    SearchComponent.prototype.clearResults = function () {
        this.results = {};
        this.typeResults = [];
    };
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Boolean)
    ], SearchComponent.prototype, "addSelectionToMap", void 0);
    tslib_1.__decorate([
        InputConverter(BooleanConverter),
        tslib_1.__metadata("design:type", Object)
    ], SearchComponent.prototype, "filterLayersBeforeAdd", void 0);
    tslib_1.__decorate([
        InputConverter(JSONConverter),
        tslib_1.__metadata("design:type", Array)
    ], SearchComponent.prototype, "excludeTypes", void 0);
    tslib_1.__decorate([
        InputConverter(BooleanConverter),
        tslib_1.__metadata("design:type", Object)
    ], SearchComponent.prototype, "enableNotificationSearch", void 0);
    return SearchComponent;
}(BaseComponent));
export { SearchComponent };
